import LeadFormListener from "./custom/form/LeadFormListener";
import { Smoother } from "./custom/Smoother";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Swiper from "swiper";
import {EffectFade, Keyboard, Navigation, Pagination, Autoplay} from "swiper/modules";
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

const leadFormListener = new LeadFormListener();

document.addEventListener('DOMContentLoaded', () => {
    if (window.scrollX > 0) { // Fix na przesunięcie po odświeżeniu strony, spowodowane istnieniem elementu typu fixed.
        window.scrollBy((window.scrollX * -1), 0);
    }

    const swiper = new Swiper('.swiper-homepage .swiper', {
        direction: 'horizontal',
        loop: true,
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 0
            }
        },
        effect: "fade",
        grabCursor: true,
        autoplay: {
            pauseOnMouseEnter: true,
            delay: 10000
        },
        modules: [Navigation, Keyboard, EffectFade, Pagination, Autoplay],
        keyboard: {
            enabled: true,
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
            bulletClass: "swiper-button",
            bulletActiveClass: "active"
        },
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });

    const smoother = new Smoother({
        smooth: 1,
        effects: true,
        smoothTouch: .25
    });

    const inViewport = (entries, observer) => {
        entries.forEach(entry => {
            entry.target.classList.toggle("is-in-viewport", entry.isIntersecting);
        });
    };

    const Obs = new IntersectionObserver(inViewport);
    const obsOptions = {}; //See: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API#Intersection_observer_options

    document.querySelectorAll('.list.list-check').forEach(el => {
        let i = 0;
        el.querySelectorAll('li').forEach(item => {
            item.style.setProperty('--sibling-index', i);
            i++;
        })
        Obs.observe(el, obsOptions);
    });

    setTimeout(() => {
        AOS.init();
    }, 120);
});